import React, { useRef, useState } from "react";
import { Camera, CheckCircle2, Loader2, Briefcase } from "lucide-react";
import { api, LOGO_URL } from "../lib/api";

// ---------- Переводы RU / UZ ----------
const T = {
  ru: {
    badge: "Приём заявок на работу",
    tagline: "Ассалому алейкум! 👋 Спасибо за интерес к работе в нашей команде. Пожалуйста, заполните анкету ниже.",
    photo: "Фото",
    photoHint: "Недавнее, чёткое фото лица",
    photoBtn: "Загрузить фото лица",
    photoChange: "Изменить фото",
    fio: "Ф.И.О.",
    fioHint: "Фамилия, имя, отчество",
    age: "Возраст",
    phone: "Номер телефона",
    address: "Адрес проживания",
    position: "На какую должность хотите устроиться?",
    experience: "Опыт работы",
    experienceHint: "Где работали? В какой должности? Сколько времени работали?",
    education: "Образование",
    educationHint: "Среднее, среднее специальное, высшее и название учебного заведения",
    langsTitle: "Какие языки знаете?",
    langsHint: "Отметьте язык и выберите уровень владения",
    langRussian: "Русский",
    langUzbek: "Узбекский",
    langEnglish: "Английский",
    more: "Ещё",
    moreHint: "Если знаете другие языки — напишите здесь",
    schedule: "Какой график работы вам удобен?",
    scheduleHint: "Полный рабочий день, сменная работа и т.д.",
    about: "Кратко о себе",
    aboutHint: "Сильные стороны, личные качества и почему хотите работать в нашей команде",
    start: "Когда можете приступить к работе?",
    startAsap: "Как можно скорее",
    startCommentPh: "Или напишите свой вариант",
    submit: "Отправить заявку",
    submitting: "Отправка...",
    footerNote: "Ваши данные будут рассмотрены командой CRAFT Fast Food.",
    levels: { beginner: "Начальный", inter: "Средний", fluent: "Свободно", native: "Родной" },
    errPhoto: "Пожалуйста, приложите фото лица — это обязательно",
    errRequired: "Пожалуйста, заполните все поля — они обязательные",
    errLang: "Отметьте хотя бы один язык и выберите его уровень",
    errStart: "Укажите, когда можете приступить к работе",
    errPhotoBig: "Фото слишком большое, выберите другое",
    errSend: "Ошибка отправки. Проверьте интернет и попробуйте снова",
    successTitle: "Спасибо! 😊",
    successText: "Ваша заявка отправлена. После рассмотрения, если ваша кандидатура нам подойдёт, мы обязательно с вами свяжемся.",
    successWish: "Желаем удачи и будем рады видеть вас в нашей команде!",
  },
  uz: {
    badge: "Ishga qabul qilish",
    tagline: "Assalomu alaykum! 👋 Jamoamizda ishlashga qiziqish bildirganingiz uchun rahmat. Iltimos, quyidagi anketani to'ldiring.",
    photo: "Surat",
    photoHint: "Yaqinda olingan, aniq ko'rinadigan yuz surati",
    photoBtn: "Yuz suratini yuklash",
    photoChange: "Suratni o'zgartirish",
    fio: "F.I.Sh.",
    fioHint: "Familiya, ism, sharif",
    age: "Yoshingiz",
    phone: "Telefon raqamingiz",
    address: "Yashash manzilingiz",
    position: "Qaysi lavozimga ishga kirmoqchisiz?",
    experience: "Ish tajribangiz",
    experienceHint: "Qayerda ishlagansiz? Qaysi lavozimda? Qancha muddat ishlagansiz?",
    education: "Ma'lumotingiz",
    educationHint: "O'rta, o'rta maxsus, oliy va ta'lim muassasasi nomi",
    langsTitle: "Qaysi tillarni bilasiz?",
    langsHint: "Tilni belgilang va bilish darajasini tanlang",
    langRussian: "Rus tili",
    langUzbek: "O'zbek tili",
    langEnglish: "Ingliz tili",
    more: "Yana",
    moreHint: "Agar boshqa tillarni bilsangiz — shu yerga yozing",
    schedule: "Sizga qaysi ish jadvali qulay?",
    scheduleHint: "To'liq ish kuni, smenali ish va hokazo",
    about: "O'zingiz haqingizda qisqacha",
    aboutHint: "Kuchli tomonlaringiz, shaxsiy fazilatlaringiz va nega aynan bizning jamoada ishlashni xohlaysiz?",
    start: "Ishni qachondan boshlay olasiz?",
    startAsap: "Imkon qadar tezroq",
    startCommentPh: "Yoki o'z variantingizni yozing",
    submit: "Arizani yuborish",
    submitting: "Yuborilmoqda...",
    footerNote: "Ma'lumotlaringiz CRAFT Fast Food jamoasi tomonidan ko'rib chiqiladi.",
    levels: { beginner: "Boshlang'ich", inter: "O'rta", fluent: "Erkin", native: "Ona tili" },
    errPhoto: "Iltimos, yuz suratini biriktiring — bu majburiy",
    errRequired: "Iltimos, barcha maydonlarni to'ldiring — ular majburiy",
    errLang: "Kamida bitta tilni belgilang va darajasini tanlang",
    errStart: "Ishni qachon boshlay olishingizni ko'rsating",
    errPhotoBig: "Surat juda katta, boshqasini tanlang",
    errSend: "Yuborishda xatolik. Internetni tekshiring va qayta urinib ko'ring",
    successTitle: "Rahmat! 😊",
    successText: "Arizangiz yuborildi. Ko'rib chiqilgandan so'ng, agar nomzodingiz bizga mos kelsa, albatta siz bilan bog'lanamiz.",
    successWish: "Sizga omad tilaymiz va jamoamizda ko'rishdan mamnun bo'lamiz!",
  },
};

const LEVEL_KEYS = ["beginner", "inter", "fluent", "native"];
// Канонические названия для отправки в админку (всегда по-русски)
const LANG_RU = { russian: "Русский", uzbek: "Узбекский", english: "Английский" };
const LEVEL_RU = { beginner: "Начальный", inter: "Средний", fluent: "Свободно", native: "Родной" };

function detectLang() {
  try {
    const l = (navigator.language || navigator.userLanguage || "ru").toLowerCase();
    if (l.startsWith("uz")) return "uz";
    return "ru";
  } catch {
    return "ru";
  }
}

function compressPhoto(file, maxSize = 800, quality = 0.82) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        let { width, height } = img;
        if (width > height && width > maxSize) { height = Math.round((height * maxSize) / width); width = maxSize; }
        else if (height > maxSize) { width = Math.round((width * maxSize) / height); height = maxSize; }
        const canvas = document.createElement("canvas");
        canvas.width = width; canvas.height = height;
        canvas.getContext("2d").drawImage(img, 0, 0, width, height);
        resolve(canvas.toDataURL("image/jpeg", quality));
      };
      img.onerror = reject;
      img.src = reader.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

const INPUT_CLS = "mt-1.5 w-full rounded-xl border border-gray-200 bg-[#FBF3E4]/40 px-3 py-2.5 text-sm outline-none focus:border-[#E10514]";

function Field({ label, hint, textarea, type, value, onChange, testid, placeholder }) {
  return (
    <div>
      <label className="font-display font-bold text-sm text-black flex items-center gap-1">
        {label} <span className="text-red-500">*</span>
      </label>
      {hint && <div className="text-xs text-gray-500 mt-0.5">{hint}</div>}
      {textarea ? (
        <textarea rows={3} value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid} className={INPUT_CLS + " resize-y"} />
      ) : (
        <input type={type || "text"} value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder || ""} data-testid={testid} className={INPUT_CLS} />
      )}
    </div>
  );
}

export default function JobApplication() {
  const [lang, setLang] = useState(detectLang());
  const t = T[lang];
  const [form, setForm] = useState({});
  const [langs, setLangs] = useState({ russian: null, uzbek: null, english: null }); // key -> levelKey | null
  const [langMore, setLangMore] = useState("");
  const [startAsap, setStartAsap] = useState(false);
  const [startComment, setStartComment] = useState("");
  const [photo, setPhoto] = useState(null);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const fileRef = useRef(null);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  // Модель langs[key]: undefined/null = не выбран, "" = выбран без уровня, levelKey = выбран с уровнем
  const selectLang = (key) => setLangs((s) => ({ ...s, [key]: s[key] == null ? "" : null }));
  // Повторный клик по тому же уровню снимает уровень (язык остаётся выбранным)
  const setLevel = (key, lvl) => setLangs((s) => ({ ...s, [key]: s[key] === lvl ? "" : lvl }));

  const onPhoto = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    try { setPhoto(await compressPhoto(file)); setError(""); }
    catch { setError(t.errPhoto); }
  };

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!photo) { setError(t.errPhoto); window.scrollTo({ top: 0, behavior: "smooth" }); return; }
    const req = ["fio", "age", "phone", "address", "position", "experience", "education", "schedule", "about"];
    for (const k of req) {
      if (!(form[k] || "").trim()) { setError(t.errRequired); window.scrollTo({ top: 0, behavior: "smooth" }); return; }
    }
    // языки: хотя бы один выбран с уровнем
    const chosen = Object.entries(langs).filter(([, v]) => !!v);
    if (chosen.length === 0) { setError(t.errLang); window.scrollTo({ top: 0, behavior: "smooth" }); return; }
    // старт: как можно скорее ИЛИ комментарий
    if (!startAsap && !startComment.trim()) { setError(t.errStart); window.scrollTo({ top: 0, behavior: "smooth" }); return; }

    const languagesStr =
      chosen.map(([k, lvl]) => `${LANG_RU[k]} — ${LEVEL_RU[lvl] || ""}`.trim()).join(", ") +
      (langMore.trim() ? `; ещё: ${langMore.trim()}` : "");
    const startStr = startAsap
      ? (startComment.trim() ? `Как можно скорее (${startComment.trim()})` : "Как можно скорее")
      : startComment.trim();

    setBusy(true);
    try {
      const payload = {
        fio: form.fio, age: form.age, phone: form.phone, address: form.address,
        position: form.position, experience: form.experience, education: form.education,
        languages: languagesStr, schedule: form.schedule, about: form.about,
        start_date: startStr, photo, lang,
      };
      const { data } = await api.post("/job-applications", payload);
      if (data.success) { setDone(true); window.scrollTo({ top: 0, behavior: "smooth" }); }
      else if (data.error === "photo_too_large") setError(t.errPhotoBig);
      else setError(t.errRequired);
    } catch {
      setError(t.errSend);
    }
    setBusy(false);
  };

  if (done) {
    return (
      <div className="min-h-screen bg-[#FBF3E4] flex items-center justify-center p-5 font-sans">
        <div className="w-full max-w-[460px] bg-white rounded-3xl p-8 text-center shadow-xl">
          <div className="w-16 h-16 mx-auto rounded-full bg-green-100 flex items-center justify-center mb-4">
            <CheckCircle2 className="text-green-600" size={36} />
          </div>
          <h1 className="font-display font-black text-2xl text-black">{t.successTitle}</h1>
          <p className="text-gray-600 mt-3 leading-relaxed">{t.successText}</p>
          <p className="text-gray-500 mt-3 text-sm">{t.successWish}</p>
          <div className="mt-6 flex items-center justify-center gap-2 text-[#E10514] font-display font-black">
            <img src={LOGO_URL} alt="" className="w-8 h-8 rounded-lg" /> CRAFT Fast Food
          </div>
        </div>
      </div>
    );
  }

  const langRows = [["russian", t.langRussian], ["uzbek", t.langUzbek], ["english", t.langEnglish]];

  return (
    <div className="min-h-screen bg-[#FBF3E4] font-sans pb-12">
      {/* Шапка */}
      <div className="bg-[#E10514] text-white">
        <div className="max-w-[560px] mx-auto px-5 pt-4 pb-7">
          {/* Переключатель языка — отдельная строка, не перекрывает текст */}
          <div className="flex justify-end">
            <div className="inline-flex rounded-full bg-black/25 p-1">
              {["ru", "uz"].map((l) => (
                <button key={l} type="button" onClick={() => setLang(l)} data-testid={`lang-${l}`}
                  className={`px-3 py-1 rounded-full text-xs font-black uppercase transition-colors ${lang === l ? "bg-white text-[#E10514]" : "text-white/90"}`}>
                  {l}
                </button>
              ))}
            </div>
          </div>
          <div className="text-center mt-1">
            <div className="flex items-center justify-center gap-2 mb-3">
              <img src={LOGO_URL} alt="" className="w-10 h-10 rounded-xl" />
              <span className="font-display font-black text-xl">CRAFT Fast Food</span>
            </div>
            <div className="inline-flex items-center gap-2 bg-black/25 rounded-full px-4 py-1.5 font-display font-black uppercase tracking-wide text-sm">
              <Briefcase size={16} /> {t.badge}
            </div>
            <p className="mt-4 text-white/90 leading-relaxed text-sm">{t.tagline}</p>
          </div>
        </div>
      </div>

      <form onSubmit={submit} className="max-w-[560px] mx-auto px-5 mt-5 space-y-5">
        {error && (
          <div className="bg-red-50 border border-red-200 text-red-700 rounded-2xl px-4 py-3 text-sm font-bold" data-testid="job-error">{error}</div>
        )}

        {/* Фото лица */}
        <div className="bg-white rounded-3xl p-5 shadow-sm">
          <div className="font-display font-black text-black flex items-center gap-1.5">{t.photo} <span className="text-red-500">*</span></div>
          <div className="text-xs text-gray-500 mt-0.5 mb-4">{t.photoHint}</div>
          <input ref={fileRef} type="file" accept="image/*" onChange={onPhoto} className="hidden" data-testid="job-photo-input" />
          <button type="button" onClick={() => fileRef.current?.click()} className="w-full flex flex-col items-center gap-3">
            {photo ? (
              <img src={photo} alt="" className="w-32 h-32 rounded-2xl object-cover border-4 border-[#FEBC10]" />
            ) : (
              <div className="w-32 h-32 rounded-2xl border-2 border-dashed border-gray-300 bg-[#FBF3E4] flex items-center justify-center"><Camera className="text-gray-400" size={34} /></div>
            )}
            <span className="inline-flex items-center gap-2 bg-black text-[#FEBC10] font-display font-black rounded-full px-5 py-2 text-sm">
              <Camera size={16} /> {photo ? t.photoChange : t.photoBtn}
            </span>
          </button>
        </div>

        {/* Текстовые поля (все обязательные) */}
        <div className="bg-white rounded-3xl p-5 shadow-sm space-y-4">
          <Field label={t.fio} hint={t.fioHint} value={form.fio || ""} onChange={(v) => set("fio", v)} testid="job-fio" />
          <Field label={t.age} type="number" value={form.age || ""} onChange={(v) => set("age", v)} testid="job-age" />
          <Field label={t.phone} type="tel" placeholder="+998 __ ___ __ __" value={form.phone || ""} onChange={(v) => set("phone", v)} testid="job-phone" />
          <Field label={t.address} value={form.address || ""} onChange={(v) => set("address", v)} testid="job-address" />
          <Field label={t.position} value={form.position || ""} onChange={(v) => set("position", v)} testid="job-position" />
          <Field label={t.experience} hint={t.experienceHint} textarea value={form.experience || ""} onChange={(v) => set("experience", v)} testid="job-experience" />
          <Field label={t.education} hint={t.educationHint} textarea value={form.education || ""} onChange={(v) => set("education", v)} testid="job-education" />
        </div>

        {/* Языки — чипы + уровень + «Ещё» */}
        <div className="bg-white rounded-3xl p-5 shadow-sm">
          <div className="font-display font-bold text-sm text-black flex items-center gap-1">{t.langsTitle} <span className="text-red-500">*</span></div>
          <div className="text-xs text-gray-500 mt-0.5 mb-3">{t.langsHint}</div>
          <div className="space-y-2.5">
            {langRows.map(([key, label]) => {
              const val = langs[key];
              const on = val != null; // выбран (включая "" без уровня)
              return (
                <div key={key} className="flex flex-wrap items-center gap-2">
                  <button type="button" onClick={() => selectLang(key)} data-testid={`lang-chip-${key}`}
                    className={`px-3.5 py-1.5 rounded-full text-sm font-bold border transition-colors ${on ? "bg-[#E10514] text-white border-[#E10514]" : "bg-[#FBF3E4]/60 text-gray-600 border-gray-200"}`}>
                    {label}
                  </button>
                  {on && (
                    <div className="flex flex-wrap gap-1.5">
                      {LEVEL_KEYS.map((lvl) => (
                        <button key={lvl} type="button" onClick={() => setLevel(key, lvl)} data-testid={`level-${key}-${lvl}`}
                          className={`px-2.5 py-1 rounded-full text-xs font-bold transition-colors ${val === lvl ? "bg-[#FEBC10] text-black" : "bg-gray-100 text-gray-500"}`}>
                          {t.levels[lvl]}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
          <div className="mt-3">
            <label className="text-xs text-gray-500">{t.more}</label>
            <input type="text" value={langMore} onChange={(e) => setLangMore(e.target.value)} placeholder={t.moreHint} data-testid="job-lang-more" className={INPUT_CLS} />
          </div>
        </div>

        {/* График + О себе */}
        <div className="bg-white rounded-3xl p-5 shadow-sm space-y-4">
          <Field label={t.schedule} hint={t.scheduleHint} value={form.schedule || ""} onChange={(v) => set("schedule", v)} testid="job-schedule" />
          <Field label={t.about} hint={t.aboutHint} textarea value={form.about || ""} onChange={(v) => set("about", v)} testid="job-about" />
        </div>

        {/* Когда приступить — готовый ответ или комментарий */}
        <div className="bg-white rounded-3xl p-5 shadow-sm">
          <div className="font-display font-bold text-sm text-black flex items-center gap-1">{t.start} <span className="text-red-500">*</span></div>
          <div className="mt-3 flex flex-wrap items-center gap-2">
            <button type="button" onClick={() => setStartAsap((v) => !v)} data-testid="start-asap"
              className={`px-4 py-2 rounded-full text-sm font-bold border transition-colors ${startAsap ? "bg-[#E10514] text-white border-[#E10514]" : "bg-[#FBF3E4]/60 text-gray-600 border-gray-200"}`}>
              {t.startAsap}
            </button>
          </div>
          <input type="text" value={startComment} onChange={(e) => setStartComment(e.target.value)} placeholder={t.startCommentPh} data-testid="job-start-comment" className={INPUT_CLS} />
        </div>

        <button type="submit" disabled={busy} data-testid="job-submit-btn"
          className="w-full bg-[#E10514] hover:bg-[#c40412] disabled:opacity-60 text-white font-display font-black rounded-2xl py-4 text-lg flex items-center justify-center gap-2 shadow-lg">
          {busy ? <><Loader2 className="animate-spin" size={20} /> {t.submitting}</> : t.submit}
        </button>
        <p className="text-center text-xs text-gray-400 pb-4">{t.footerNote}</p>
      </form>
    </div>
  );
}
